// extracted by mini-css-extract-plugin
export var anchorLink = "anchorLinkNavigation-module--anchorLink--246be";
export var anchorLinkNavigation = "anchorLinkNavigation-module--anchorLinkNavigation--e316b";
export var mobileOnly = "anchorLinkNavigation-module--mobileOnly--ea3cf";
export var tabletOrBigger = "anchorLinkNavigation-module--tabletOrBigger--fdf78";